var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudioFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 0H0.497523C0.114711 0 -0.124352 0.417188 0.0678357 0.75L3.70221 6.92813V10.6875C3.70221 10.9641 3.92409 11.1875 4.19909 11.1875H8.29909C8.57409 11.1875 8.79596 10.9641 8.79596 10.6875V6.92813L12.4319 0.75C12.6225 0.417188 12.3835 0 12.0006 0ZM7.67721 10.0625H4.82096V7.625H7.67877V10.0625H7.67721ZM7.82721 6.36563L7.67877 6.625H4.8194L4.67096 6.36563L1.57252 1.125H10.9256L7.82721 6.36563Z",
    fill: "#59616D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioFilterIcon);
export default __webpack_public_path__ + "static/media/studio_filter_icon.eee45460b70caf79f605de272ee56ce8.svg";
export { ForwardRef as ReactComponent };